'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SidebarLink = exports.Sidebar = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _glamor = require('glamor');

var _Pane = require('./Pane');

var _Pane2 = _interopRequireDefault(_Pane);

var _Text = require('./Text');

var _Text2 = _interopRequireDefault(_Text);

var _Link = require('./Link');

var _Link2 = _interopRequireDefault(_Link);

var _Triangle = require('./Triangle');

var _Triangle2 = _interopRequireDefault(_Triangle);

var _theme = require('./theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var minorScale = _theme2.default.minorScale,
    majorScale = _theme2.default.majorScale;


var SidebarLink = function SidebarLink(_ref) {
  var children = _ref.children,
      active = _ref.active,
      props = _objectWithoutProperties(_ref, ['children', 'active']);

  return _react2.default.createElement(
    _Link2.default,
    _extends({ textStyle: 'body1' }, (0, _glamor.css)({
      '&:hover, &.active': {
        backgroundColor: _theme2.default.rawColors.blue50
      }
    }), { active: active }, props),
    _react2.default.createElement(
      _Text2.default,
      { is: 'span', flexAuto: true },
      children
    ),
    active ? _react2.default.createElement(_Triangle2.default, { aim: 'right', fill: _theme2.default.intent.secondary.active.linkColor }) : null
  );
};

SidebarLink.defaultProps = {
  is: 'a',
  secondary: true,
  display: 'flex',
  alignItems: 'center',
  paddingX: majorScale(1),
  paddingY: minorScale(1),
  marginBottom: minorScale(1),
  rounded: true
};

var Sidebar = function Sidebar(props) {
  return _react2.default.createElement(_Pane2.default, props);
};

Sidebar.defaultProps = {
  white: true,
  borderRight: true,
  width: majorScale(30),
  padding: majorScale(2),
  flex: '0 0 auto'
};

exports.Sidebar = Sidebar;
exports.SidebarLink = SidebarLink;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-ui-library/lib/components/Sidebar.js
// module id = 1133
// module chunks = 0